import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, first, map, tap } from 'rxjs/operators';
import { DeviceStoreSelectors } from '../device-store';
import { LatestDeviceDiagnosticsActions as LatestDeviceDiagnosticsStoreActions } from '../latest-device-diagnostics';

@Injectable({ providedIn: 'root' })
export class LatestDeviceDiagnosticsResolver {
  private readonly store = inject(Store);

  resolve(): Observable<boolean> {
    return this.store.select(DeviceStoreSelectors.selectCurrentLocationDevices).pipe(
      filter((devices) => devices.length > 0),
      tap((devices) => {
        this.store.dispatch(
          LatestDeviceDiagnosticsStoreActions.LatestDeviceDiagnosticsActions.latestDeviceDiagnosticsRequested({
            udids: devices.map((device) => device.udid),
          })
        );
      }),
      map(() => true),
      first()
    );
  }
}
